// Tabs.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const Tabs = () => {
  const tabs = [
    { name: 'Workflows', path: '/' },
    { name: 'Templates', path: '/templates' },
    { name: 'Portal Builder Templates', path: '/portal-builder-templates' },
    { name: 'Landing Page', path: '/landing-page' },
  ];

  return (
    <div style={{ display: 'flex', marginBottom: '20px' }}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.name}
          to={tab.path}
          style={({ isActive }) => ({
            padding: '10px 20px',
            cursor: 'pointer',
            fontWeight: isActive ? 'bold' : 'normal',
            color: isActive ? 'var(--primary-color)' : '#666',
            borderBottom: isActive ? '2px solid var(--primary-color);' : 'none',
            marginRight: '20px',
            textDecoration: 'none',
          })}
        >
          {tab.name}
        </NavLink>
      ))}
    </div>
  );
};

export default Tabs;
